"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// must be kept in-sync with
// https://source.justgiving.com/JustGiving/JG.FrontEnd.Toolkit/blob/master/packages/styles/src/settings/_breakpoints.scss

var XSMALL = exports.XSMALL = 320; // 0-319
var SMALL = exports.SMALL = 568; // 320-567
var MEDIUM = exports.MEDIUM = 768; // 568-767
var LARGE = exports.LARGE = 1024; // 768-1023
var XLARGE = exports.XLARGE = 1240; // 1024-1240

exports.default = {
  XSMALL: XSMALL,
  SMALL: SMALL,
  MEDIUM: MEDIUM,
  LARGE: LARGE,
  XLARGE: XLARGE
};


// WEBPACK FOOTER //
// ../~/@jg/components/es/Responsive/constants/breakpoints.js